














import { Vue, Component } from 'vue-property-decorator'
import LanguageSwitcher from '~/components/LanguageSwitcher.vue'

@Component({
    components: {
        LanguageSwitcher,
    }
})
export default class Header extends Vue {
    get drawer(): boolean {
        return this.$store.getters.drawer
    }

    setDrawer(arg0: boolean): void {
        this.$store.dispatch('setDrawer', arg0)
    }
}
